<template>
  <div class="alert">
    <div class="alert-image">
      <img
        class="img"
        src="@/assets/img/alert/precaucion.png"
        alt="Alert Sign"
      />
    </div>
    <div class="alert-text">
      {{ msg }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["msg"],
};
</script>

<style scoped>
.img{
  width:50px
}


.alert {
  border-radius: 50px !important;
  background-color: #24C6AB !important;
  display: flex;
  align-items: center;
  width: 40%;
}

.alert-image {
  justify-content: left;
}

.alert-text {
  align-self: left;
  font-size: 10px;
  font-weight: bold;
  margin: 1rem;
}

@media screen and (max-width: 900px) {
  .img {
    width: 30px;
  }
  .alert-text {
    font-size: 8px;
    margin: 0;
  }
}

/* @media screen and (max-width: 767px) {
  .alert {
    margin-left: 90px !important;
    max-width: 50%;
  }

  .img {
    width: 20px;
  }
  .alert-text {
    font-size: 8px;
    margin: 0;
  }
} */
</style>
